import AuthenticationService from '@core/services/authentication/AuthenticationService';
import User from '@models/user/User';

export async function activateAccount(
    this: AuthenticationService,
    token: string,
    multiLoginDestination: string | null,
): Promise<User> {
    await this.restService.activateAccount(token, multiLoginDestination);

    return this.getSession();
}
